import { API } from "../../api";
const BASE_URL = "/cooperatives/settings/support";

export const supportSettingsExtendedApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getSupportSettings: builder.query({
      query: () => `${BASE_URL}?guard=staff`,
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "SupportSettings", id: "CURRENT" }],
    }),
    updateSupportSettings: builder.mutation({
      query: (body) => ({
        url: `${BASE_URL}/update?guard=staff`,
        method: "POST",
        body: body,
      }),
      transformResponse: (responseData) => responseData, // Return full response to check status
      invalidatesTags: [{ type: "SupportSettings", id: "CURRENT" }],
    }),
  }),
});

export const {
  useGetSupportSettingsQuery,
  useUpdateSupportSettingsMutation,
} = supportSettingsExtendedApi;
